import { Text } from 'components';
import React, { memo } from 'react';
import { TableComponents } from 'screens/Admin/components';
import { ListItem } from './';

// Hoisted so its identity is stable — as an inline arrow it was a fresh component every
// render of the screen above.
const Header = () => (
  <React.Fragment>
    <TableComponents.Th first>
      <Text>Thumbnail</Text>
    </TableComponents.Th>
    <TableComponents.Th>
      <Text>Owner</Text>
    </TableComponents.Th>
    <TableComponents.Th>
      <Text>Team</Text>
    </TableComponents.Th>
    <TableComponents.Th>
      <Text>Type</Text>
    </TableComponents.Th>
    <TableComponents.Th>
      <Text>Caption</Text>
    </TableComponents.Th>
    <TableComponents.Th>
      <Text>Views</Text>
    </TableComponents.Th>
    <TableComponents.Th>
      <Text>Reactions</Text>
    </TableComponents.Th>
    <TableComponents.Th>
      <Text>Posted At</Text>
    </TableComponents.Th>
    <TableComponents.Th last>
      <Text>Actions</Text>
    </TableComponents.Th>
  </React.Fragment>
);

// memo matters here: the screen above re-renders on summary fetches and filter edits, none of
// which change the rows. Its callbacks are memoized so those renders stop at this boundary.
const List = memo(({ data, onClick, onRequestDelete, dataId, loading }) => {
  return (
    <TableComponents.List
      loading={loading || !data}
      Header={Header}
      Items={() =>
        !loading && data
          ? data.map((item, i) => (
              <ListItem
                key={item._id || i}
                // A boolean, not dataId — passing the id made every row re-render whenever
                // the selection changed.
                isSelected={dataId === item._id}
                onClick={onClick}
                onRequestDelete={onRequestDelete}
                item={item}
              />
            ))
          : null
      }
    />
  );
});

export default List;
